import { render, staticRenderFns } from "./Monograph.vue?vue&type=template&id=69688c78&scoped=true"
import script from "./Monograph.vue?vue&type=script&lang=js"
export * from "./Monograph.vue?vue&type=script&lang=js"
import style0 from "./Monograph.vue?vue&type=style&index=0&id=69688c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69688c78",
  null
  
)

export default component.exports